import { SELECTION_TYPE } from '@/utils/constants/commonConstants'

export const getSelectionType = selection => {
  switch (selection) {
    //for single select implementation is not done as per peacock
    case SELECTION_TYPE.SINGLE:
      return SELECTION_TYPE.SINGLE
    //this will be same
    case SELECTION_TYPE.MULTIPLE:
      return SELECTION_TYPE.MULTIPLE
    default:
      //default return should be single
      return SELECTION_TYPE.SINGLE
  }
}
